module.exports = __webpack_public_path__ + "static/media/AI.62a80673.png";